<ion-app>
  <ion-split-pane  when="(min-width: 2500px)">
    <ion-menu>
      <ion-header>
        <ion-toolbar color="dark" class="user-profile">
          <div *ngIf="member">
            <ion-item margin-bottom>
              <ion-avatar slot="start" class="user-avatar">
                <img src="assets/img/profile.png">
              </ion-avatar>
              <ion-label>
                <ion-text color="tertiary">
                  <h3><strong>{{member.ClientName}}</strong></h3>
                </ion-text>
                <ion-text color="secondary">
                  <h3>
                    <strong>{{member.ClientEmail}}</strong>
                  </h3>
                </ion-text>
                <ion-menu-toggle class="mto" auto-hide="false">
                  <!-- <a class="text08" tappable (click)="goToEditProfile()">
                    <ion-text color="tertiary">
                      <ion-icon name="contact"></ion-icon>
                      <strong>{{ 'app.pages.menu.editprofile' | translate }}</strong>
                    </ion-text>
                  </a> 
                  <ion-text color="secondary"> | </ion-text>  -->
                  <a class="text08" tappable (click)="logout()">
                    <ion-text color="tertiary">
                      <ion-icon name="log-out"></ion-icon>
                      <strong>{{ 'app.pages.menu.logout' | translate }}</strong>
                    </ion-text>
                  </a>
                </ion-menu-toggle>
              </ion-label>
            
            </ion-item>
          </div>
        </ion-toolbar>
      </ion-header>
      <ion-content class="bg-profile">
        <ion-list>
          <ion-menu-toggle *ngFor="let p of appPages">
            <ion-item [routerLink]="[p.url]" color="primary">
              <ion-icon slot="start" [name]="p.icon" color="light"></ion-icon>
              <ion-label>
                {{p.title | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet main></ion-router-outlet>
  </ion-split-pane>
</ion-app>
